import DealRequestEncoder from '../aeron/v2/TradeDealRequestEncoder.js';
import MessageHeaderEncoder from '../aeron/MessageHeaderEncoder.js'

const encodeDealRequest = (data) => {
    const asDecimal = (value) => {
        if (value && value.mantissa !== undefined && value.exponent !== undefined) {
            return value;
        }

        return {
            mantissa: 0,
            exponent: 0
        };
    };

    const normalizedLegs = data.legs.map((leg) => ({
        ...leg,
        spot: asDecimal(leg.spot),
        fwd: asDecimal(leg.fwd),
        price: asDecimal(leg.price)
    }));

    const groupHeaderLength = 4; // Adjust for legs header

    const bufferLength = DealRequestEncoder.BLOCK_LENGTH +
                         MessageHeaderEncoder.ENCODED_LENGTH + 
                         groupHeaderLength +
                         normalizedLegs.length * DealRequestEncoder.LEG_BLOCK_LENGTH; // Adjust for legs data

    const buffer = new ArrayBuffer(bufferLength);
    const headerEncoder = new MessageHeaderEncoder();
    const encoder = new DealRequestEncoder();

    // Encode the data
    encoder.wrapAndApplyHeader(buffer, 0, headerEncoder);

    // Encode the main fields
    encoder.transactionType(data.transactionType)
            .symbol(data.symbol)
            .transactTime(data.transactTime)
            .messageTime(data.messageTime)
            .quoteRequestID(data.quoteRequestID)
            .quoteID(data.quoteID)
            .dealRequestID(data.dealRequestID)
            .clientID(data.clientID);

    // Encode legs
    encoder.encodeLeg(normalizedLegs); 

    return buffer;
};

export default encodeDealRequest;

